import { render, staticRenderFns } from "./SearchDatastoreTables.vue?vue&type=template&id=7bac2548&"
import script from "./SearchDatastoreTables.vue?vue&type=script&lang=js&"
export * from "./SearchDatastoreTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports